import { render, staticRenderFns } from "./PropertyTestimonials.vue?vue&type=template&id=a6f716d2&scoped=true&"
import script from "./PropertyTestimonials.vue?vue&type=script&lang=js&"
export * from "./PropertyTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTestimonials.vue?vue&type=style&index=0&id=a6f716d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f716d2",
  null
  
)

export default component.exports